var _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.58,16.17h-3.65v12.04h3.65v-12.04Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.37,20.92v7.3h-3.65v-5.84c0-2.71-.62-3.47-1.92-3.47-1.48,0-2.83,1.89-2.83,4.68v4.63h-3.65v-12.04h3.65v.57c0,.55-.11.93-.3,1.3-.18.37-.41.82-.11.93.27.11.38-.16.48-.34.57-1.21,1.92-2.83,3.99-2.83,2.6,0,4.33,1.69,4.33,5.1h0s0,0,0,0h0Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.62,16.17h3.88l2.17,7.75c.11.43.16,1.1.16,1.62,0,.23.05.5.37.5s.37-.27.37-.5c0-.52.05-1.19.16-1.62l2.17-7.75h3.88l-4.01,12.04h-5.11l-4.01-12.04h0,0Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.16,22.19c0,3.51-2.41,6.38-6.38,6.38s-6.38-2.87-6.38-6.38,2.41-6.38,6.38-6.38,6.38,2.87,6.38,6.38ZM83.52,22.19c0-1.78-.93-3.28-2.74-3.28s-2.74,1.51-2.74,3.28.93,3.29,2.74,3.29,2.74-1.51,2.74-3.29Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.56,13.55c.16-.99-.52-1.93-1.51-2.09-.99-.16-1.93.52-2.1,1.51s.52,1.93,1.51,2.09c.99.16,1.93-.52,2.1-1.51Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.41,3.51H8.1c-2.67,0-4.83,2.16-4.83,4.83v23.31c0,2.67,2.16,4.83,4.83,4.83h23.31c2.67,0,4.83-2.16,4.83-4.83V8.34c0-2.67-2.16-4.83-4.83-4.83h0Z",
    fill: "#87e64b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.01,12.96c0-.32-.26-.58-.58-.58h-4.94c-.32,0-.58.26-.58.58v3.91c0,.32.26.58.58.58h1.02c2.48,0,4.49-2.01,4.49-4.49h0Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.43,17.74c-3.05,0-5.52,2.47-5.52,5.52v3.79c0,.32.26.58.58.58h4.94c.32,0,.58-.26.58-.58v-8.72c0-.32-.26-.58-.58-.58h0Z",
    fill: "#191919"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.28,12.39h-4.16c-.17,0-.31.24-.31.53v2.6c0,.29-.14.52-.31.52h-2.07c-.17,0-.31-.23-.31-.52v-2.6c0-.29-.14-.53-.31-.53h-4.16c-.17,0-.31.24-.31.53v5.33c0,.23.19.43.43.43h2.88c.2,0,.36.16.36.35v1.99c0,.2-.16.35-.36.35h-2.88c-.23,0-.43.19-.43.43v5.3c0,.29.14.52.31.52h4.16c.17,0,.31-.24.31-.52v-2.67c0-.29.14-.53.31-.53h2.07c.17,0,.31.24.31.53v2.67c0,.29.14.52.31.52h4.16c.17,0,.31-.24.31-.52v-14.18c0-.29-.14-.53-.31-.53h0Z",
    fill: "#191919"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.38,20.94v7.31h-3.66v-5.85c0-2.72-.62-3.47-1.92-3.47-1.49,0-2.83,1.9-2.83,4.69v4.64h-3.66V11.79h3.66v4.96c0,.55-.11.94-.3,1.3-.18.37-.41.82-.11.94.27.11.39-.16.48-.34.57-1.21,1.92-2.83,4-2.83,2.6,0,4.34,1.69,4.34,5.12h0Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,23.5v-7.31h3.66v5.85c0,2.72.62,3.47,1.92,3.47,1.49,0,2.83-1.9,2.83-4.69v-4.64h3.66v12.07h-3.66v-.57c0-.55.11-.94.3-1.3.18-.37.41-.82.11-.94-.27-.11-.39.16-.48.34-.59,1.19-1.92,2.83-4,2.83-2.6,0-4.34-1.69-4.34-5.12h0Z",
    fill: "#fffbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59,11.79v4.75c0,.34-.09.69-.25,1.01-.18.39-.48.8-.18.94.27.14.43-.18.53-.34.75-1.39,1.96-2.33,3.79-2.33,3.32,0,5.26,2.83,5.26,6.4s-1.94,6.4-5.26,6.4c-1.81,0-3.04-.91-3.79-2.36-.07-.14-.18-.39-.41-.32-.34.11-.14.5.05.89.18.32.27.64.27.98v.43h-3.66V11.79h3.66ZM125.07,22.22c0-1.76-.82-3.29-2.65-3.29s-2.83,1.53-2.83,3.29,1.1,3.29,2.83,3.29c1.83,0,2.65-1.53,2.65-3.29Z",
    fill: "#fffbf3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.eeba321cc627f1879acd3dc39b916ff7.svg";
export { ForwardRef as ReactComponent };